var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHideAnnotationsTool = function SvgHideAnnotationsTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 36,
    height: 34
  }), /*#__PURE__*/React.createElement("path", {
    className: "annotation-path",
    fill: "#1500ff",
    d: "M23.5 20.188c3.542 0 6.566 2.202 7.792 5.312-1.226 3.11-4.25 5.313-7.792 5.313s-6.566-2.203-7.792-5.313c1.226-3.11 4.25-5.313 7.792-5.313ZM18 5c7.732 0 14 4.477 14 10 0 1.967-.795 3.801-2.168 5.348a10.348 10.348 0 0 0-1.725-1.08C29.31 18.013 30 16.538 30 15c0-4.246-5.256-8-12-8S6 10.754 6 15c0 2.095 1.271 4.132 3.585 5.665.562.372.795.839.905 1.357.045.212.06.412.06.628 0 .213-.015.448-.046.722l-.086.658-.331 1.994 3.778-2.076.475-.249c-.183.344-.348.7-.492 1.068l-.29.733.29.733-2.818 1.555-.814.434c-1.106.578-1.98.975-2.216.896-.78-.262.907-6.503.48-6.785C5.726 20.506 4 17.897 4 15 4 9.477 10.268 5 18 5Zm5.5 16.958a3.543 3.543 0 0 0-3.542 3.542 3.543 3.543 0 0 0 3.542 3.542 3.543 3.543 0 0 0 3.542-3.542 3.543 3.543 0 0 0-3.542-3.542Zm0 1.417c1.176 0 2.125.95 2.125 2.125 0 1.176-.95 2.125-2.125 2.125a2.122 2.122 0 0 1-2.125-2.125c0-1.176.95-2.125 2.125-2.125ZM17.074 9.876l8.955 1.482-6.432 6.404-.944-2.955c-.62.36-1.261.787-1.923 1.283a27.677 27.677 0 0 0-3.952 3.58l-.67.742-1.484-1.34.67-.742a29.672 29.672 0 0 1 4.236-3.84 20.864 20.864 0 0 1 2.5-1.627l-.956-2.987Z"
  }))));
};

export default SvgHideAnnotationsTool;